import {
	SvgAppIcon,
} from 'components/svg/Svg';
import './logo.scss';

/**
 * A component for displaying the TakeCargo logo
 * @param size - The css size of the logo. The default size is 6.5rem
 * @constructor
 */
export const Logo = ({
	size = '6.25rem',
}: {size?: string}) => (
	<SvgAppIcon
		className="tc-logo"
		style={{
			width: size,
			height: size,
		}}/>
);